import React from 'react';
import {Layout} from "antd";
import QwHeader from "../../layout/header";
import QwSider from "./sider";
import {Route, Switch} from "react-router-dom";
import Contact from "../../layout/contact";
import loadable from "../../loadable";
import Drainage from "../drainage/index";
import CloudStepPro from "../../config/scanstep/cloud_step";
import CloudApi from "../cloud_api";
import CorpApi from "../../public/corp_api";
import Store from "../../store";
import PubSub from "pubsub-js";
import Utils from "../../public/utils";
import noPermissions from "../../config/noPermissions/noPermissions";
import {connect} from "react-redux";

const TalkLib = loadable(() => import('../talklib/index'))//话术库
const SeatManage = loadable(() => import('../seat/seat_manage'));
const AccountOperation = loadable(() => import('../account/index'));
const Customer = loadable(() => import('../customer/index'));
const GroupChat = loadable(() => import('../groupchat/index'));
const CustOperation = loadable(() => import('../cust_operation/index'));

const {Content} = Layout;

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
        this.state = {
            customerServiceFlag: 1,
            accountMessage: {},//账号信息
        }
    }

    componentDidMount() {
        // this.handleResize();
        // window.addEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        CorpApi.getUserOpenId((data) => {
            this.setState({
                accountMessage: data
            })
            this.props.subAction(data)
            Store.setUserInfo(data);
            PubSub.publish('WX_WORK_HELPR_PRO_ACCOUNT', data)
        })
        CloudApi.getUserAddCustStatus(data => {
            //0未添加，1已添加
            this.setState({
                customerServiceFlag: data.customerserviceflag
            })
        })
    }

    handleResize() {
        let width = window.innerWidth;
        if (width > 1300) {
            this.toggleSiderCollapsed(false);
        } else {
            this.toggleSiderCollapsed(true);
        }
    }

    toggleSiderCollapsed = (val) => {
        if (this.qySiderRef) {
            this.qySiderRef.collapseChange(val);
        }
    };

    render() {
        const {customerServiceFlag, accountMessage} = this.state
        return (
            <Layout className='qy-layout dark'>
                <QwHeader key='qyHeader' toggleSiderCollapsed={this.toggleSiderCollapsed}
                          history={this.props.history} type='3'/>
                <Layout>
                    <QwSider key='qySider' ref={r => this.qySiderRef = r} history={this.props.history}
                             accountMessage={accountMessage}/>
                    <Content className='qy-content-wraper'>
                        <div className='qy-content'>
                            <Contact/>
                            <Switch>
                                {/*话术库*/}
                                <Route path={this.props.match.url + "/talklib"}
                                       component={customerServiceFlag == 1 ? TalkLib : CloudStepPro}>
                                </Route>
                                {/*账号管理*/}
                                {
                                    this.props.subInfo.isSub == 0 ?
                                        <Route path={this.props.match.url + "/seat"}
                                               component={customerServiceFlag == 1 ? SeatManage : CloudStepPro}></Route> :
                                        this.props.subInfo.isSub == 1 ?
                                        <Route path={this.props.match.url + "/seat"}
                                               component={Utils.wxWorkHelperProJurisdiction(this.props.subInfo.permissionConf, 'account', 'account_seat') ?
                                                   (customerServiceFlag == 1 ? SeatManage : CloudStepPro) : noPermissions}></Route> : <></>
                                }
                                <Route path={this.props.match.url + "/drainage"}
                                       component={customerServiceFlag == 1 ? Drainage : CloudStepPro}>
                                </Route>
                                <Route path={this.props.match.url + "/account"}
                                       component={customerServiceFlag == 1 ? AccountOperation : CloudStepPro}>
                                </Route>
                                <Route path={this.props.match.url + "/customer"}
                                       component={customerServiceFlag == 1 ? Customer : CloudStepPro}>
                                </Route>
                                <Route path={this.props.match.url + "/groupchat"}
                                       component={customerServiceFlag == 1 ? GroupChat : CloudStepPro}>
                                </Route>
                                <Route path={this.props.match.url + "/cust-operation"}
                                       component={customerServiceFlag == 1 ? CustOperation : CloudStepPro}>
                                </Route>
                            </Switch>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo:subReducer
    }
},null)(Index)